import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';  // FontAwesome icons
import './index.css';  // Global styles (font family, root variables, etc.)
import 'bootstrap/dist/css/bootstrap.min.css';  // Bootstrap styles
import 'bootstrap/dist/js/bootstrap.bundle.min';  // Bootstrap JS (for functionality)
import './assets/css/style.css';  // Main custom styles (this should be last to apply overrides)
import './assets/css/anshika.css';  // Additional custom styles
import './assets/css/sarwar.css';  // Custom styles (if they need to load before style.css)
import './assets/css/responsive.css';  // Responsive styles
import './assets/css/sudeep.css'

import { GoogleOAuthProvider } from '@react-oauth/google';
import MasterProvider from 'provider/MasterProvider';
import MetaProvider from 'provider/MetaProvider';
import { AuthProvider } from 'provider/AuthContext';
import SafariPackagesProvider from 'provider/SharePackagesProvider';
import ParksProvider from 'provider/ParksProvider';
import { ToastProvider } from 'provider/ToastProvider';
import SharedSafariProvider from 'provider/ShareSafariProvider';
import ProfileProvider from 'provider/ProfileProvider';
import { ScreenSizeProvider } from 'provider/ScreenSizeProvider';
import OperatorProfileProvider from 'provider/OperatorProfileProvider';
import HomeProvider from 'provider/HomeProvider';
import ParksViewProvider from 'provider/ParkViewProvider';
import WishListProvider from 'provider/WishListProvider';



const clientId = process.env.REACT_APP_GOOGLE_AUTH;  //walkintowild Web Application
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
      <MasterProvider>
        <MetaProvider>
          <ScreenSizeProvider>
            <HomeProvider>
              <SharedSafariProvider>
                <AuthProvider>
                  <ProfileProvider>
                    <OperatorProfileProvider>
                      <ToastProvider>
                        <SafariPackagesProvider>
                          <ParksProvider>
                            <ParksViewProvider>
                              <WishListProvider>
                              <App />
                              </WishListProvider>
                            </ParksViewProvider>
                          </ParksProvider>
                        </SafariPackagesProvider>
                      </ToastProvider>
                    </OperatorProfileProvider>
                  </ProfileProvider>
                </AuthProvider>
              </SharedSafariProvider>
            </HomeProvider>
          </ScreenSizeProvider>
        </MetaProvider>
      </MasterProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();


// 106811897499435890403